import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }                     from '../api/api.service';
import { CompanyCancellationReasonModel } from './models/company.cancellation-reason';
import { ConfirmService }                 from '../../app-lite/messages/confirm/confirm.service';
import { MessagesService }                from '../messages/messages.service';
import { SessionService }                 from '../sessions/session.service';

@Component({
  selector   : 'wor-cancel-subscription',
  template: require('./company.cancel-subscription.component.html')
})
export class CancelSubscriptionComponent {
  maxLength        = 5000;
  showCommentError = false;

  reasons : Array<CompanyCancellationReasonModel> = [
    {
      id       : 'cbPE',
      selected : false,
      translate: 'COMPANY_SPACE.CHARGIFY.REASON_PE',
      value    : 'PE'
    },{
      id       : 'cbSE',
      selected : false,
      translate: 'COMPANY_SPACE.CHARGIFY.REASON_SE',
      value    : 'SE'
    },{
      id       : 'cbBCC',
      selected : false,
      translate: 'COMPANY_SPACE.CHARGIFY.REASON_BCC',
      value    : 'BCC'
    },{
      id       : 'cbTTU',
      selected : false,
      translate: 'COMPANY_SPACE.CHARGIFY.REASON_TTU',
      value    : 'TTU'
    }
  ];

  @Input() subscription : any;

  constructor (
    private activeModal     : NgbActiveModal,
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private messagesService : MessagesService,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  cancelSubscription () : void {
    const selectedReason = this.reasons.filter(reason => reason.selected);

    if (selectedReason.length) {


      this.subscription.reason_of_cancelation = selectedReason[0].value;


    }

    this.confirmService.generic('Are you sure you want to cancel your subscription with Workshop Software?')
    .then(() => {
      return this.apiService.post('/chargify/cancel_subscription', {
        cancellation_message : this.subscription.cancellation_message || this.translateService.instant('COMPANY_SPACE.CHARGIFY.NO_ADDITIONAL_COMMENTS_PROVIDED'),
        reason_of_cancelation: this.subscription.reason_of_cancelation,
        subscription         : this.subscription
      });
    })
    .then(() => this.sessionService.refresh())
    .then(() => {
      this.activeModal.close();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  handleReasonSelection ( reason : CompanyCancellationReasonModel ) {
    for ( let i = 0; i < this.reasons.length; i++ ) {
      if (this.reasons[i].id !== reason.id) {

        this.reasons[i].selected = false;

        };

      }
  }
}